<template>
  <div class="container">
    <img src="../assets/imgs/110/bg.jpg" class="bg" alt="" />
    <div class="phone" style="top: 22.2rem;">
      <a href="tel:028-82595053" style="color:#000">82595053</a>,
      <a href="tel:028-82593582" style="color:#000">82593582</a>
    </div>
    <div class="phone" style="top: 26.05rem;">
      <a href="tel:028-82420330" style="color:#000">82420330</a>
    </div>
    <div class="phone" style="top: 29rem;">
      <a href="tel:028-82595053" style="color:#000">82595053</a>,
      <a href="tel:028-82593582" style="color:#000">82593582</a>
    </div>
    <div class="phone" style="top: 31.75rem;">
      <a href="tel:028-82595053" style="color:#000">82595053</a>,
      <a href="tel:028-82593582" style="color:#000">82593582</a>
    </div>
    <div class="phone" style="top: 36.8rem;left:4.65rem">
      <a href="tel:028-82479907" style="color:#000">82479907</a>
    </div>
    <div class="phone" style="top: 39.15rem;left:4.65rem">
      <a href="tel:028-82479907" style="color:#000">82479907</a>
    </div>
    <div class="phone" style="top: 41.82rem;left:5.4rem">
      <a href="tel:028-82479907" style="color:#000">82479907</a>
    </div>
    <div class="phone" style="top: 45.28rem;">
      <a href="tel:028-82420330" style="color:#000">82420330</a>,
      <a href="tel:028-82479907" style="color:#000">82479907</a>
    </div>
    <div class="phone" style="top: 48.3rem;">
      <a href="tel:028-69700046" style="color:#000">69700046</a>
    </div>
    <div class="phone" style="top: 52.62rem;left:4.65rem">
      <a href="tel:028-82479907" style="color:#000">82479907</a>
    </div>
    <div class="phone" style="top: 57.52rem;">
      <a href="tel:028-82479907" style="color:#000">82479907</a>
    </div>
    <div class="phone" style="top: 61.7rem;">
      <a href="tel:028-82485381" style="color:#000">82485381</a>,
      <a href="tel:028-82516563" style="color:#000">82516563</a>
    </div>
    <div class="phone" style="top: 64.8rem;">
      <a href="tel:028-82595053" style="color:#000">82595053</a>,
      <a href="tel:028-82593582" style="color:#000">82593582</a>
    </div>
    <div class="phone" style="top: 71.25rem;">
      <a href="tel:028-82516318" style="color:#000">82516318</a>
    </div>
    <div class="phone" style="top:73.55rem;left:5.45rem">
      <a href="tel:028-82516318" style="color:#000">82516318</a>
    </div>
    <div class="phone" style="top:76.45rem;left:4.9rem">
      <a href="tel:028-82593434" style="color:#000">82593434</a>,
      <a href="tel:028-82485381" style="color:#000">82485381</a>
    </div>
    <div class="phone" style="top: 79.6rem;">
      <a href="tel:028-82593434" style="color:#000">82593434</a>
    </div>
    <div class="phone" style="top: 87.35rem;">
      <a href="tel:028-82479907" style="color:#000">82479907</a>
    </div>
    <div class="phone" style="top:89.95rem;left:5.25rem">
      <a href="tel:028-82517011" style="color:#000">82517011</a>
    </div>
    <div class="phone" style="top:94.15rem;left:5.55rem">
      <a href="tel:028-82420330" style="color:#000">82420330</a>
    </div>
    <div class="phone" style="top: 97.93rem;">
      <a href="tel:028-82522793" style="color:#000">82522793</a>
    </div>
    <div class="phone" style="top: 103.2rem;">
      <a href="tel:028-82516636" style="color:#000">82516636</a>,
      <a href="tel:028-60728100" style="color:#000">60728100</a>,
      <a href="tel:028-82590699" style="color:#000">82590699</a>,
      <a href="tel:028-82516416" style="color:#000">82516416</a>
    </div>
    <div class="phone" style="top: 106.93rem;">
      <a href="tel:028-82420330" style="color:#000">82420330</a>
    </div>
    <div class="phone" style="top: 111.05rem;">
      <a href="tel:028-82526025" style="color:#000">82526025</a>
    </div>
    <div class="phone" style="top: 114.45rem;">
      <a href="tel:028-82420330" style="color:#000">82420330</a>
    </div>
    <div class="phone" style="top:120.25rem;left:6rem">
      <a href="tel:028-82529901" style="color:#000">82529901</a>
    </div>
    <div class="phone" style="top:124.7rem;left:5.35rem">
      <a href="tel:028-82517032" style="color:#000">82517032</a>
    </div>
    <img src="../assets/imgs/110/code.png" class="code" alt="">
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {},
};
</script>


<style lang="scss" scoped>
.container {
  width: 100vw;
  color: #000;
  position: relative;
  .bg {
    width: 100%;
    height: 137rem;
    display: block;
  }
  .phone {
    position: absolute;
    left: 1.8rem;
    font-size: 0.22rem;
    font-weight: bold;
    
  }
  .code{
    width: 2.3rem;
    height: 2.3rem;
    position: absolute;
    left: 50%;
    bottom: 7.8rem;
    transform: translateX(-50%);
  }
}
</style>